import { ChangeDetectorRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService, private _ref: ChangeDetectorRef, @Inject('i18n-label') private place: any) {
  }

  private onRepoChange: Subscription | undefined;
  private value = '';



  transform(key: string, defaultValue: string, vo: Record<string, string> | undefined = undefined, ...args: unknown[]): string {

    this.translate.registerPlace(this.place, key);

    if (this.onRepoChange == undefined) {
      this.onRepoChange = this.translate.currentStaticRepo.subscribe(repo => {
        let value = repo[key];
        if (value != undefined) {
          this.value = this.translate.interpolate(value, vo);
        } else {
          this.value = this.translate.interpolate(defaultValue, vo);
        }
        this._ref.markForCheck();
        // if (key == "Nieuw") {
        //   console.log(this.place, key);
        // }
      });
    }
    return this.value;
  }

  _dispose() {
    if (this.onRepoChange != undefined) {
      this.onRepoChange.unsubscribe();
      this.onRepoChange = undefined;
    }
  }

}
